import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Button, Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { AppState, useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { setIsBackButtonEnable } from 'src/store/SiteConatctInfo';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setSitestudypersonnelData } from 'src/store/sitestudypersonnelData';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import SiteInformation from './SiteInformation';
import SitePersonal from './SitePersonal';
import { useSiteContactInfo } from './useSitecontactinfo';

const SiteContactInfo: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const [expanded, setExpanded] = useState(true);
  const [expanded2, setExpanded2] = useState(false);
  const [sitestudySiteInfo, setSitestudySiteInfo] = useState<any>({});
  const { sciErrorMsg, nextTxt } = useFieldTranslation();
  const { user } = useUser();

  //const sitestudypersonnelData = useSelector((state: AppState) => state.sitestudypersonnelData.sitestudypersonnelData);
  const {
    siteStudyPersonnelQueryData,
    siteStudyPersonnelQueryDataIsSuccess,
    siteStudyPersonnelQueryDataLoading,
    updateSiteInfoSuccess,
    updateStudyIdentifiedSuccess,
    updateSitePersonalSuccess,
    createSitePersonalSuccess,
    updateSitePersonalFicsSuccess,
    siteStudyPersonnelQueryDataError,
    getSiteStudyPersonnelQueryData,
    createSitePersonal,
    updateSitePersonal,
    updateSitePersonalFics,
    siteTsdaStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryDataIsSuccess,
    siteTsdaStudyPersonnelQueryDataLoading
  } = useSiteContactInfo();

  const [sitePersonnelCount, setSitePersonnelCount] = useState(0);
  const [sitePersonnelData, setSitePersonnelData] = useState<any>({
    site_per_number: 0,
    site_per_first_name: '',
    site_per_last_name: '',
    site_per_login: '',
    site_per_email: '',
    site_per_phone: '',
    site_per_role: '',
    site_per_designation: '',
    site_per_study: '',
    site_per_startdate: '',
    site_per_frole: '',
    site_per_enddate: undefined,
    site_per_activities: '',
    site_per_training: true,
    site_per_DOAlink: 'DOA',
    site_per_1572link: '1572',
    site_per_sivtrainloglink: 'SIV Training log',
    created_by: user
  });
  const [isEnableAddPer, setIsEnableAddPer] = useState(false);
  const [isEnableSave, setIsEnableSave] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const fromNavigationPathName: any = useAppSelector(state => {
    return state.navigationPath.navigationPathName;
  });
  const [list, setList] = useState<any>([]);
  const studyId = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const [ficsTraining, setFicsTraining] = useState(0);
  const isBackButtonEnable = useAppSelector(state => state.siteConatctInfo.isBackButtonEnable);
  const dispatch = useDispatch();
  const hadleChangePersonalStudyActivities = (id: any, activities: any) => {
    if (Array.isArray(sitestudySiteInfo?.personnel)) {
      const updatedData = sitestudySiteInfo?.personnel.map((obj: any) => {
        if (obj.id == id) {
          return { ...obj, site_per_activities: activities };
        } else {
          return obj;
        }
      });
      setSitestudySiteInfo({ ...sitestudySiteInfo, personnel: updatedData });
      setConfirmExitValue(dispatch, true);
      setFicsTraining(ficsTraining + 1);
    }
    setConfirmExitValue(dispatch, true);
  };
  const hadleOptionChangePersonal = (id: any, e: any) => {
    if (Array.isArray(sitestudySiteInfo?.personnel)) {
      const updatedData = sitestudySiteInfo?.personnel.map((obj: any) => {
        if (obj.id == id) {
          return { ...obj, [e.target.name]: e.target.value };
        } else {
          return obj;
        }
      });
      setSitestudySiteInfo({ ...sitestudySiteInfo, personnel: updatedData });
      setConfirmExitValue(dispatch, true);
      setFicsTraining(ficsTraining + 1);
    }
    setConfirmExitValue(dispatch, true);
  };
  const [updateStudyActivities, setupdateStudyActivities] = React.useState<string[]>([]);
  const hadleOptionChangeStudyActivities = (id: any, e: any) => {
    if (Array.isArray(sitestudySiteInfo?.personnel)) {
      const updatedData = sitestudySiteInfo?.personnel.map((obj: any) => {
        if (obj.id == id) {
          setupdateStudyActivities(typeof e.targetvalue === 'string' ? e.targetvalue.split(',') : '');
          return { ...obj, [e.target.name]: e.targetvalue.split(',') };
        } else {
          return obj;
        }
      });
      setSitestudySiteInfo({ ...sitestudySiteInfo, personnel: updatedData });
      setConfirmExitValue(dispatch, true);
      setFicsTraining(ficsTraining + 1);
    }
  };

  const [siteInfoData, setSiteInfoData] = useState<any>({});

  const handleToogleAccordion = () => {
    setExpanded(!expanded);
    setExpanded2(false);
  };
  const handleToogleAccordion2 = () => {
    setExpanded2(!expanded2);
    setExpanded(false);
  };

  useEffect(() => {
    if (siteStudyPersonnelQueryDataError) {
      setSitestudypersonnelData(dispatch, []);
    }
  }, [siteStudyPersonnelQueryDataError]);

  const getData = async (funcCall = '') => {
    const res: any = await getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      site_users: true
    });
    setSitestudySiteInfo(res?.data);
    setList(res?.data?.personnel);
    setSiteInfoData(res?.data?.site);
    setSitePersonnelCount(res?.data?.personnel?.length);
    if (funcCall !== '') {
      console.debug('funcCall', funcCall);
    } else {
      setFicsTraining(ficsTraining + 1);
    }
  };

  const updateSiteStudyPersonnel = (data: any) => {
    const compareData = async () => {
      localStorage.setItem('selectedSiteLocal', selectedSite == null ? '' : selectedSite);
      const res: any = await getSiteStudyPersonnelQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application,
        site_users: true
      });
      const result: any = res?.data;
      if (JSON.stringify(result?.personnel) !== JSON.stringify(data)) {
        const siteStudyPersonnelData: any = {
          personnel: []
        };
        if (checkPermission('create_site_personnel')) {
          data.map((item: any, index: any) => {
            const temp = {
              site_per_first_name: item.site_per_first_name,
              site_per_last_name: item.site_per_last_name,
              site_per_email: item.site_per_email,
              site_per_designation: item.site_per_designation,
              site_per_role: item.site_per_role,
              site_per_activities: item.site_per_activities,
              site_per_frole: item.site_per_frole,
              site_per_phone: item.site_per_phone,
              site_per_study: item.site_per_study,
              site_per_startdate: item.site_per_startdate,
              site_per_enddate: item.site_per_enddate,
              site_per_login: item.site_per_login,
              personnel_id: item.id,
              fics_system: item.fics_system ? item.fics_system : 'Study side FICS- CTMS'
            };
            siteStudyPersonnelData.personnel[index] = temp;
          });
        } else {
          data.map((item: any, index: any) => {
            const temp = {
              is_fics_required: item.site_per_training,
              personnel_id: item.id
            };
            siteStudyPersonnelData.personnel[index] = temp;
          });
        }
        postData(siteStudyPersonnelData);
      }
      if (sitePersonnelCount !== sitestudySiteInfo?.personnel.length) {
        addPersonnel();
      }
    };
    compareData();
  };

  const addPersonnel = async () => {
    const reqPayload = { ...sitePersonnelData, application: 'CTMS', fics_system: 'Study side FICS- CTMS' };

    for (const [key, value] of Object.entries(reqPayload)) {
      if (value === '' || value === null) {
        delete reqPayload[key];
      }
    }
    const allNewPersonnel = { personnel: [reqPayload] };
    try {
      await createSitePersonal({
        study_id: studyId,
        data: allNewPersonnel,
        site_id: selectedSite,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      setConfirmExitValue(dispatch, false);
      getData('addPersonnel');
      setIsEnableAddPer(false);
      setIsEnableSave(false);
    } catch (e: any) {
      getData('addPersonnel');
      setIsEnableAddPer(false);
      setIsEnableSave(false);
    }
  };

  const postData = async (siteStudyPersonnelData: any) => {
    try {
      if (checkPermission('create_site_personnel')) {
        await updateSitePersonal({
          data: { personnel: siteStudyPersonnelData.personnel },
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME
        });
      } else {
        await updateSitePersonalFics({
          site_id: selectedSite,
          data: { ...siteStudyPersonnelData, update_by: user },
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
      }
      setConfirmExitValue(dispatch, false);
      getData('UpdatedsitePersonal');
    } catch (e: any) {
      dispatch(setMessage({ msgDetails: sciErrorMsg, severity: 'error' }));
    }
  };
  useEffect(() => {
    if (
      updateSiteInfoSuccess ||
      updateStudyIdentifiedSuccess ||
      updateSitePersonalSuccess ||
      createSitePersonalSuccess ||
      updateSitePersonalFicsSuccess
    ) {
      getData('UpdatedsitePersonal');
    }
  }, [
    updateSiteInfoSuccess,
    updateStudyIdentifiedSuccess,
    updateSitePersonalSuccess,
    createSitePersonalSuccess,
    updateSitePersonalFicsSuccess
  ]);

  useEffect(() => {
    if (fromNavigationPathName === 'startupPacket' || fromNavigationPathName === 'Summary-ContactInfo-personnel') {
      setExpanded(false);
      setExpanded2(true);
      setConfirmExitValue(dispatch, true);
    }
    getData();
  }, [selectedSite]);

  useEffect(() => {
    getData('load site');
  }, []);

  const handleClickStudyLogs = (log: string) => {
    if (log === 'DOA') {
      dispatch(setPath('DOA'));
    } else if (log === 'SIVTL') {
      dispatch(setPath('SIVTL'));
    }
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'studyLogs');
    setTabVal(currentTabinfo[0].index);
  };

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitValue(dispatch, false);
      setConfirmExitValue(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigateToTab = () => {
    if (isBackButtonEnable) {
      dispatch(setIsBackButtonEnable(false));
    }
    dispatch(setPath('ContractandBudget'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'startUpPacket');
    setTabVal(currentTabinfo[0].index);
  };

  useEffect(() => {
    return () => {
      if (isBackButtonEnable) {
        dispatch(setIsBackButtonEnable(false));
      }
    };
  }, []);
  return (
    <div className="pi-accordion lastAccordionSetting">
      {isBackButtonEnable ? (
        <Button sx={{ mb: 1 }} onClick={() => navigateToTab()} startIcon={<ArrowBackIcon fontSize="small" />}>
          BACK
        </Button>
      ) : null}
      <Accordion expanded={expanded} onChange={handleToogleAccordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Site Information</Typography>
        </AccordionSummary>
        {sitestudySiteInfo &&
        Object.keys(sitestudySiteInfo)?.length !== 0 &&
        siteInfoData &&
        Object.keys(siteInfoData)?.length ? (
          <SiteInformation
            siteStudyPersonnelQueryData={siteStudyPersonnelQueryData}
            siteStudyPersonnelQueryDataIsSuccess={siteStudyPersonnelQueryDataIsSuccess}
            siteStudyPersonnelQueryDataLoading={siteStudyPersonnelQueryDataLoading}
            siteTsdaStudyPersonnelQueryData={siteTsdaStudyPersonnelQueryData}
            siteTsdaStudyPersonnelQueryDataIsSuccess={siteTsdaStudyPersonnelQueryDataIsSuccess}
            siteTsdaStudyPersonnelQueryDataLoading={siteTsdaStudyPersonnelQueryDataLoading}
            checkedInStartDate
          />
        ) : (
          ''
        )}
      </Accordion>

      <Accordion expanded={expanded2} onChange={handleToogleAccordion2}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Site Personnel Details</Typography>
        </AccordionSummary>
        {sitestudySiteInfo &&
        Object.keys(sitestudySiteInfo).length !== 0 &&
        sitestudySiteInfo &&
        sitestudySiteInfo?.personnel ? (
          <SitePersonal
            studyId={studyId}
            updateSiteStudyPersonnel={updateSiteStudyPersonnel}
            hadleOptionChangePersonal={hadleOptionChangePersonal}
            sitestudySiteInfo={sitestudySiteInfo}
            setSitestudySiteInfo={setSitestudySiteInfo}
            sitePersonnelData={sitePersonnelData}
            setSitePersonnelData={setSitePersonnelData}
            sitePersonnelCount={sitePersonnelCount}
            setSitePersonnelCount={setSitePersonnelCount}
            isEnableAddPer={isEnableAddPer}
            setIsEnableAddPer={setIsEnableAddPer}
            isEnableSave={isEnableSave}
            setIsEnableSave={setIsEnableSave}
            ficsTraining={ficsTraining}
            getData={getData}
            updateStudyActivities={updateStudyActivities}
            hadleOptionChangeStudyActivities={hadleOptionChangeStudyActivities}
            handleClickStudyLogs={handleClickStudyLogs}
            hadleChangePersonalStudyActivities={hadleChangePersonalStudyActivities}
            list={list}
            setList={setList}
          />
        ) : (
          ''
        )}
      </Accordion>
      {currentTabinfo[0].NextButton && (
        <Grid container spacing={2} className="bottom-navigation">
          <Grid item md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              <Button variant="contained" onClick={handleNextbtn}>
                {nextTxt}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default SiteContactInfo;
